export const violetGradient = `
    background: #804dee;
    background: #c3b0ec;
    background: linear-gradient(-90deg, #804dee 0%, rgba(60, 51, 80, 0) 100%);
    background:
      -webkit-linear-gradient(
        -90deg,
        #804dee 0%,
        rgba(60, 51, 80, 0) 100%
      );
`;

export const greenPinkGradient = `
    background: "#00cea8";
    background: linear-gradient(90.13deg, #00cea8 1.9%, #bf61ff 97.5%);
    background: -webkit-linear-gradient(-90.13deg, #00cea8 1.9%, #bf61ff 97.5%);
`;

export const blackGradient = {
  background:
    `linear-gradient(
      to right,
      #434343,
      #000
    )`,
};
